// Turks (tr-TR), design: zelfde vorm als design.nl.ts. Wat ontbreekt valt terug op het Nederlands
// (nooit een rauwe sleutel op het scherm). Pictogramnamen kort en eenvoudig (kinderen lezen ze);
// zoekwoorden in het Turks, met woordgroepen als "cami_dersi" (telt in het titelvoorstel als geheel).
export const designTr = {
    picto: {
        'brush-teeth': 'Diş fırçala',
        'get-dressed': 'Giyin',
        shoes: 'Ayakkabı giy',
        coat: 'Mont giy',
        'wash-hands': 'Elleri yıka',
        toilet: 'Tuvalete git',
        shower: 'Duş al',
        bath: 'Banyo yap',
        sleep: 'Uyku',
        alarm: 'Çalar saat',
        prayer: 'Namaz',
        wudu: 'Abdest al',
        'make-bed': 'Yatağı topla',
        'tidy-up': 'Toparla',
        'set-table': 'Sofrayı kur',
        'clear-table': 'Sofrayı kaldır',
        dishes: 'Bulaşık yıka',
        dishwasher: 'Bulaşık makinesini boşalt',
        vacuum: 'Süpürge çek',
        sweep: 'Yeri süpür',
        cleaning: 'Temizlik',
        windows: 'Cam sil',
        laundry: 'Çamaşır yıka',
        'fold-laundry': 'Çamaşır katla',
        trash: 'Çöpü çıkar',
        recycling: 'Çöpleri ayır',
        'water-plants': 'Çiçekleri sula',
        garden: 'Bahçe',
        'walk-dog': 'Köpeği gezdir',
        'feed-cat': 'Kediyi besle',
        'feed-fish': 'Balıkları besle',
        'feed-rabbit': 'Tavşanı besle',
        mail: 'Posta',
        school: 'Okul',
        backpack: 'Okul çantası',
        homework: 'Ödev',
        reading: 'Kitap okuma',
        library: 'Kütüphane',
        lecture: 'Konferans',
        mosque: 'Cami dersi',
        quran: 'Kuran',
        computer: 'Bilgisayar',
        work: 'İş',
        'phone-call': 'Telefon',
        calendar: 'Randevu',
        soccer: 'Futbol',
        hockey: 'Hokey',
        swimming: 'Yüzme',
        gymnastics: 'Jimnastik',
        dance: 'Dans',
        ballet: 'Bale',
        tennis: 'Tenis',
        basketball: 'Basketbol',
        judo: 'Judo',
        'horse-riding': 'Binicilik',
        skating: 'Paten',
        running: 'Koşu',
        cycling: 'Bisiklet',
        playground: 'Oyun parkı',
        'music-lesson': 'Müzik dersi',
        piano: 'Piyano',
        guitar: 'Gitar',
        violin: 'Keman',
        drums: 'Davul',
        singing: 'Şarkı',
        theater: 'Tiyatro',
        drawing: 'Resim çizme',
        painting: 'Boyama',
        crafts: 'El işi',
        puzzle: 'Yapboz',
        play: 'Oyun',
        gaming: 'Video oyunu',
        tv: 'Televizyon',
        'screen-time': 'Ekran süresi',
        dentist: 'Diş hekimi',
        doctor: 'Doktor',
        hospital: 'Hastane',
        medicine: 'İlaç',
        sick: 'Hasta',
        haircut: 'Kuaför',
        birthday: 'Doğum günü',
        party: 'Parti',
        gift: 'Hediye',
        wish: 'Dilek',
        chat: 'Mesajlar',
        sohbet: 'Sohbet',
        grandma: 'Nine',
        grandpa: 'Dede',
        family: 'Aile',
        babysitter: 'Bakıcı',
        playdate: 'Oyun buluşması',
        sleepover: 'Pijama partisi',
        home: 'Ev',
        holiday: 'Tatil',
        travel: 'Seyahat',
        camping: 'Kamp',
        zoo: 'Hayvanat bahçesi',
        museum: 'Müze',
        cinema: 'Sinema',
        car: 'Araba',
        bus: 'Otobüs',
        train: 'Tren',
        walk: 'Yürüyüş',
        church: 'Kilise',
        shabbat: 'Şabat',
        synagogue: 'Sinagog',
        mandir: 'Mandir',
        moon: 'Ay',
        breakfast: 'Kahvaltı',
        lunch: 'Öğle yemeği',
        dinner: 'Akşam yemeği',
        fruit: 'Meyve',
        drink: 'İçecek',
        cooking: 'Yemek yapma',
        baking: 'Kek yapma',
        groceries: 'Alışveriş',
        'ice-cream': 'Dondurma',
        popcorn: 'Film gecesi',
        pizza: 'Pizza',
        pancakes: 'Krep',
        soup: 'Çorba',
        'oven-dish': 'Fırın yemeği',
        stamppot: 'Stamppot',
        lasagne: 'Lazanya',
        curry: 'Köri',
        noodles: 'Erişte',
        taco: 'Tako',
        wrap: 'Dürüm',
        salad: 'Salata',
        hamburger: 'Hamburger',
        fries: 'Patates kızartması',
        dumplings: 'Mantı',
        waffle: 'Waffle',
        pie: 'Turta',
        cake: 'Pasta',
        pudding: 'Tatlı',
        banana: 'Muz',
        pear: 'Armut',
        orange: 'Portakal',
        lemon: 'Limon',
        strawberry: 'Çilek',
        grapes: 'Üzüm',
        tomato: 'Domates',
        cucumber: 'Salatalık',
        carrot: 'Havuç',
        broccoli: 'Brokoli',
        lettuce: 'Marul',
        'bell-pepper': 'Biber',
        onion: 'Soğan',
        garlic: 'Sarımsak',
        potato: 'Patates',
        mushroom: 'Mantar',
        corn: 'Mısır',
        avocado: 'Avokado',
        cheese: 'Peynir',
        butter: 'Tereyağı',
        egg: 'Yumurta',
        yoghurt: 'Yoğurt',
        croissant: 'Kruvasan',
        honey: 'Bal',
        meat: 'Et',
        chicken: 'Tavuk',
        bacon: 'Domuz pastırması',
        fish: 'Balık',
        shrimp: 'Karides',
        sausage: 'Sosis',
        rice: 'Pirinç',
        salt: 'Tuz',
        'canned-food': 'Konserve',
        peanuts: 'Yer fıstığı',
        chocolate: 'Çikolata',
        cookie: 'Kurabiye',
        jar: 'Kavanoz',
        coffee: 'Kahve',
        tea: 'Çay',
        juice: 'Meyve suyu',
        water: 'Su',
        'toilet-paper': 'Tuvalet kâğıdı',
        soap: 'Sabun',
        sponge: 'Sünger',
        basket: 'Sepet',
        'baby-bottle': 'Bebek maması',
        receipt: 'Fiş',
        store: 'Mağaza',
        star: 'Yıldız',
        trophy: 'Kupa',
        medal: 'Madalya',
        savings: 'Birikim',
        fox: 'Tilki',
        cat: 'Kedi',
        rabbit: 'Tavşan',
        bear: 'Ayı',
        panda: 'Panda',
        koala: 'Koala',
        owl: 'Baykuş',
        lion: 'Aslan',
        tiger: 'Kaplan',
        monkey: 'Maymun',
        unicorn: 'Tek boynuzlu at',
        dino: 'Dinozor',
        turtle: 'Kaplumbağa',
        frog: 'Kurbağa',
        hedgehog: 'Kirpi',
        penguin: 'Penguen',
        dolphin: 'Yunus',
        butterfly: 'Kelebek',
        rocket: 'Roket',
        sunflower: 'Ayçiçeği',
        rainbow: 'Gökkuşağı',
        // Thema's (feat/themas): rustige, abstracte avatars.
        'shape-arch': 'Kemer',
        'shape-wave': 'Dalgalar',
        'shape-leaf': 'Yaprak',
        'shape-hills': 'Tepeler',
        'shape-ring': 'Halka',
        'shape-spark': 'Kıvılcım',
        towel: 'Havlu',
        underwear: 'İç çamaşırı',
        socks: 'Çorap',
        'swim-trunks': 'Deniz şortu',
        swimsuit: 'Mayo',
        shampoo: 'Şampuan',
        slippers: 'Terlik',
        'football-boots': 'Krampon',
        'shin-guards': 'Tekmelik',
        'water-bottle': 'Su şişesi',
        headscarf: 'Başörtüsü',
        'prayer-cap': 'Takke',
    },
    pictoKeywords: {
        // Oprichter 1 okt: lezing, en sohbet (alleen bij Turks én Islam in het gezinsprofiel).
        lecture: 'konferans seminer ders lezing lecture vortrag conference',
        sohbet: 'sohbet sohbeti muhabbet',
        mosque: 'cami camii cami_dersi kuran_kursu mescit islam kuran arapça hafızlık hoca moskee masjid',
        prayer: 'namaz dua salat teravih seccade vakit_namazı',
        wudu: 'abdest abdest_almak wudu',
        quran: 'kuran kuran_dersi hafız hafızlık tecvit elifba quran',
        church: 'kilise ayin pazar_ayini hristiyan şapel',
        shabbat: 'şabat sabbat shabbat yahudi',
        synagogue: 'sinagog havra yahudi',
        mandir: 'mandir tapınak hindu puja',
        moon: 'hilal yarım_ay ramazan',
        towel: 'havlu banyo_havlusu',
        underwear: 'iç_çamaşırı külot atlet',
        socks: 'çorap çoraplar',
        'swim-trunks': 'deniz_şortu mayo şort',
        swimsuit: 'mayo bikini',
        shampoo: 'şampuan duş_jeli sabun',
        slippers: 'terlik parmak_arası havuz_terliği',
        'football-boots': 'krampon futbol_ayakkabısı',
        'shin-guards': 'tekmelik',
        'water-bottle': 'su_şişesi matara şişe',
        headscarf: 'başörtüsü eşarp tesettür',
        'prayer-cap': 'takke namaz_takkesi',
    },
    pictoCategory: {
        routine: 'Günlük düzen',
        chores: 'Ev işleri',
        school: 'Okul ve iş',
        sport: 'Spor',
        hobby: 'Müzik ve hobi',
        care: 'Sağlık',
        family: 'Aile ve geziler',
        food: 'Yemek',
        groceries: 'Alışveriş',
        reward: 'Ödül',
        avatar: 'Hayvanlar ve karakterler',
        packing: 'Çanta hazırlama',
    },
    color: {
        orange: 'Turuncu',
        skyblue: 'Açık mavi',
        bluishgreen: 'Yeşil',
        yellow: 'Sarı',
        blue: 'Mavi',
        vermillion: 'Kırmızı',
        reddishpurple: 'Pembe',
        black: 'Gri',
    },
    eventCard: {
        allDay: 'Tüm gün',
        cancelled: 'İptal',
        everyone: 'Herkes',
        whoDrives: 'Kim gidecek?',
        drives: 'Sürücü: {name}',
        splitDrives: '{dropoff} götürüyor · {pickup} alıyor',
        repeat: 'Tekrarlanıyor',
        moved: 'Taşındı',
        changed: 'Değişti',
    },
    check: {
        label: '{task}: bitti mi?',
        confirm: 'Bitti!',
        undo: 'Hay aksi',
    },
    points: {
        earned: { one: '{count} puan', other: '{count} puan' },
        reserved: '{count} ayrıldı',
    },
    progress: '{done}/{total} bitti',
    celebrate: {
        task: 'Aferin, {name}!',
        allDone: 'Hepsi bitti!',
        /** Rustig, buiten het thema Kinderen (oprichter okt 2026: geen uitroeptekens of lof). */
        calm: {
            confirm: 'Tamamlandı',
            task: '{name} yaptı',
            allDone: 'Bugünlük her şey tamam',
        },
    },
    colorPicker: {
        label: 'Renk',
        takenBy: 'Bunu zaten seçen: {name}',
        takenOne: '{color} rengini {name} seçti',
    },
    iconPicker: {
        label: 'Simge',
        search: 'Simge ara',
        none: 'Simge yok',
        noResults: '“{query}” için sonuç yok',
        all: 'Tümü',
        more: '+{count} tane daha',
    },
    toast: {
        undo: 'Geri al',
        dismiss: 'Uyarıyı kapat',
    },
    dialog: {
        close: 'Kapat',
        fullScreen: 'Tam ekran',
        smallScreen: 'Küçült',
    },
    calendar: {
        weekShort: 'hf',
        more: '+{count} daha',
        moreShort: '+{count}',
        now: 'Şimdi',
    },
    editor: {
        title: 'Başlık',
        titleHint: 'Kısa ve net, örneğin Yüzme dersi',
        repeat: 'Tekrarla',
        repeatNone: 'Tekrarlama',
        repeatDaily: 'Her gün',
        repeatWeekly: 'Her {weekday}',
        repeatMonthly: 'Her ay',
        duplicate: 'Kopyala',
        approvalRequired: 'Onay gerekli',
        approvalHint: 'Puanlar sayılmadan önce anne ya da baba görevi onaylar.',
        deleteQuestion: '{title} silinsin mi?',
        repeatsWeekly: 'Bu etkinlik her hafta tekrarlanır.',
    },
    scope: {
        editTitle: 'Neyi değiştirmek istiyorsun?',
        deleteTitle: 'Neyi silmek istiyorsun?',
        this: 'Sadece bu sefer',
        following: 'Bu ve sonrakiler',
        all: 'Tüm seri',
        times: { one: '{count} kez', other: '{count} kez' },
        from: '{date} itibarıyla',
    },
    view: {
        label: 'Görünüm',
        day: 'Gün',
        week: 'Hafta',
        month: 'Ay',
    },
    inbox: {
        label: 'Onaylar',
        open: 'Açık',
        done: 'Tamamlanan',
    },
    empty: {
        welcomeTitle: 'Hoş geldiniz',
        welcomeBody: 'Haftayı birlikte, zahmetsizce görün. Önce ailenle başlayalım.',
        emptyDayTitle: 'Bugün plan yok',
        emptyDayBody: 'Sakin bir gün. Güzel bir şey yapmaya ne dersiniz?',
        noTasksTitle: 'Bugün görev yok',
        noTasksBody: 'Keyfini çıkar!',
        allDoneTitle: 'Her şey tamam',
        allDoneBody: 'Açık iş kalmadı.',
        offlineTitle: 'Şu an bağlantı yok',
        offlineBody: 'Son durumu görüyorsun. Kendiliğinden düzelecek.',
        nightTitle: 'İyi uykular',
        nightBody: 'Yarın saat {time}: {title}',
        rewardsTitle: 'Henüz ödül yok',
        rewardsBody: 'Birlikte biriktirecek bir şey düşünün.',
        inviteTitle: 'Eşini davet et',
        inviteBody: 'Birlikte planlamak daha kolay. E-postayla bir davet gönder.',
        oopsTitle: 'Eyvah, bir şeyler ters gitti',
        oopsBody: 'Bir kez daha dene. Olmuyor mu? Sayfayı yeniden yükle.',
        pairTitle: 'Tableti bağla',
        pairBody: 'Tablette aile panosunu aç ve kodu buraya yaz.',
    },
    credits: 'Resimler, simgeler ve çizimler: AMUMIN',
    gallery: {
        title: 'Tasarım galerisi',
        intro: 'Aile panosunun tüm yapı taşları tek yerde: token’lar, bileşenler, piktogramlar ve çizimler. Sadece geliştirme ortamında görünür.',
        theme: 'Tema',
        themeLight: 'Gündüz',
        themeDark: 'Akşam',
        themeNight: 'Gece',
        colors: 'Renkler',
        memberColors: 'Üye renkleri',
        neutrals: 'Nötr renkler',
        semantic: 'Anlam',
        typography: 'Tipografi',
        spacing: 'Boşluk ve şekiller',
        kiosk: 'Kiosk yapı taşları',
        web: 'Web uygulaması yapı taşları',
        icons: 'Simgeler',
        pictograms: 'Piktogramlar',
        illustrations: 'Çizimler',
        sample: 'Örnek',
    },
};
//# sourceMappingURL=design.tr.js.map